import { render, staticRenderFns } from "./ngwElement.vue?vue&type=template&id=429c32ba&"
import script from "./ngwElement.vue?vue&type=script&lang=js&"
export * from "./ngwElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports